import moment from 'moment';

/**
 * The report's date range is not optional. `GetByDueDateRangeAsync` always filters `ScheduledSendDate`
 * between both bounds, so omitting one sends `DateTime.MinValue` and the report matches nothing at all.
 * An unset side becomes an open-ended sentinel rather than being left off the request.
 */
const OPEN_ENDED_START = '1970-01-01';
const OPEN_ENDED_END = '2999-12-31';
const DATE_URL_FORMAT = 'YYYY-MM-DD';

// Both bounds are inclusive, so a day picked as the end of the range has to reach the end of that day —
// otherwise a blog scheduled at 9am on the chosen day falls outside it.
const bound = (value: string, fallback: string, edge: 'start' | 'end') => {
	const parsed = moment(value, DATE_URL_FORMAT, true);
	const base = parsed.isValid() ? parsed : moment(fallback, DATE_URL_FORMAT, true);
	return (edge === 'start' ? base.startOf('day') : base.endOf('day')).toISOString();
};

export const blogReportDateBounds = (from: string, to: string) => ({
	endDate: bound(to, OPEN_ENDED_END, 'end'),
	startDate: bound(from, OPEN_ENDED_START, 'start'),
});
